import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function Shell({ children, title }) {
  const { logout } = useAuth();
  const { t } = useTranslation();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white relative">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(230,0,0,0.12)_0%,transparent_70%)] pointer-events-none" />
      <header className="relative max-w-md mx-auto px-5 pt-6 flex items-center justify-between">
        <Link to="/home" className="flex items-center gap-2 text-zinc-300 hover:text-white" data-testid="shell-back">
          <ArrowLeft size={18} className="rtl:rotate-180"/> <span>{t("nav.home")}</span>
        </Link>
        {title && <span className="font-mono-accent text-zinc-400">{title}</span>}
        <button onClick={()=>{ logout(); nav("/"); }} data-testid="shell-logout" aria-label={t("nav.logout")} className="text-zinc-500 hover:text-white"><LogOut size={16}/></button>
      </header>
      <main className="relative max-w-md w-full mx-auto px-5 py-6 pb-20 fade-up">
        {children}
      </main>
    </div>
  );
}
